import React, { useState, useEffect, useContext } from 'react';
import CashRegisterOpen from './cashRegisterOpen';
import CashMovementDialog from './cashMovement';
import { CashMovementType } from 'common/types';
import { appContext } from 'common/contexts/appContext';

// Custom event names
export const OPEN_CASH_REGISTER_EVENT = 'openCashRegister';
export const ADD_CASH_EVENT = 'addCash';
export const WITHDRAW_CASH_EVENT = 'withdrawCash';

// Functions to dispatch custom events
export const openCashRegister = () => {
  const event = new CustomEvent(OPEN_CASH_REGISTER_EVENT);
  window.dispatchEvent(event);
};

export const addCash = () => {
  const event = new CustomEvent(ADD_CASH_EVENT);
  window.dispatchEvent(event);
};

export const withdrawCash = () => {
  const event = new CustomEvent(WITHDRAW_CASH_EVENT);
  window.dispatchEvent(event);
};

const CashRegisterManager: React.FC = () => {
  const [showOpenDialog, setShowOpenDialog] = useState<boolean>(false);
  const [showAddDialog, setShowAddDialog] = useState<boolean>(false);
  const [showWithdrawDialog, setShowWithdrawDialog] = useState<boolean>(false);
  const { state } = useContext(appContext);

  useEffect(() => {
    // Add event listeners for custom events
    const handleOpenRegister = () => setShowOpenDialog(true);
    const handleAddCash = () => setShowAddDialog(true);
    const handleWithdrawCash = () => setShowWithdrawDialog(true);

    window.addEventListener(OPEN_CASH_REGISTER_EVENT, handleOpenRegister);
    window.addEventListener(ADD_CASH_EVENT, handleAddCash);
    window.addEventListener(WITHDRAW_CASH_EVENT, handleWithdrawCash);

    // Clean up event listeners
    return () => {
      window.removeEventListener(OPEN_CASH_REGISTER_EVENT, handleOpenRegister);
      window.removeEventListener(ADD_CASH_EVENT, handleAddCash);
      window.removeEventListener(WITHDRAW_CASH_EVENT, handleWithdrawCash);
    };
  }, []);

  return (
    <>
      <CashRegisterOpen 
        isOpen={showOpenDialog} 
        onClose={() => setShowOpenDialog(false)} 
      />
      <CashMovementDialog 
        isOpen={showAddDialog} 
        onClose={() => setShowAddDialog(false)} 
        type={CashMovementType.ADDITION}
      />
      <CashMovementDialog 
        isOpen={showWithdrawDialog} 
        onClose={() => setShowWithdrawDialog(false)} 
        type={CashMovementType.WITHDRAWAL}
      />
    </>
  );
};

export default CashRegisterManager;
